export default "__VITE_ASSET__CCo7cuY7__"